export default __webpack_public_path__ + "static/media/ImTopic.fe694614.jpeg";